/**
 * Traducciones de ítems de listados (/lists).
 * Códigos alineados con front/src/locales/index.js (en, es, fr, uk, pt).
 */

export const LIST_I18N_LOCALE_CODES = ["en", "es", "fr", "uk", "pt"];

/**
 * @param {string} [locale]
 * @returns {string}
 */
export function normalizeListLocaleCode(locale) {
  if (!locale || typeof locale !== "string") return "es";
  const base = locale.split("-")[0].toLowerCase();
  return LIST_I18N_LOCALE_CODES.includes(base) ? base : "es";
}

/**
 * Texto mostrado para un valor de lista según el idioma activo.
 * Usa `labels[locale]` si existe y no está vacío; si no, `label` (nombre por defecto).
 *
 * @param {object|null|undefined} item
 * @param {string} [locale]
 * @returns {string}
 */
export function getTranslatedListLabel(item, locale) {
  if (!item || typeof item !== "object") return "";
  const loc = normalizeListLocaleCode(locale);
  const labels = item.labels;
  if (labels && typeof labels === "object" && !Array.isArray(labels)) {
    const v = labels[loc];
    if (v != null && String(v).trim() !== "") {
      return String(v).trim();
    }
  }
  if (item.label != null && item.label !== "") return String(item.label);
  return "";
}

/**
 * Vista compacta para administración: "Nombre | es: Hola | en: Hello | ..."
 * Solo incluye idiomas con texto en `labels`.
 *
 * @param {object|null|undefined} item
 * @returns {string}
 */
export function formatListItemLabelsLine(item) {
  if (!item || typeof item !== "object") return "";
  const main =
    item.label != null && String(item.label).trim() !== ""
      ? String(item.label).trim()
      : "";
  const segs = [];
  if (main) segs.push(main);

  const labels =
    item.labels && typeof item.labels === "object" && !Array.isArray(item.labels)
      ? item.labels
      : {};
  LIST_I18N_LOCALE_CODES.forEach((code) => {
    const v = labels[code];
    if (v != null && String(v).trim() !== "") {
      segs.push(`${code}: ${String(v).trim()}`);
    }
  });

  return segs.join(" | ");
}

/**
 * @param {object|null|undefined} item
 * @returns {boolean}
 */
export function listItemHasAnyTranslation(item) {
  if (!item?.labels || typeof item.labels !== "object" || Array.isArray(item.labels)) {
    return false;
  }
  return LIST_I18N_LOCALE_CODES.some((code) => {
    const v = item.labels[code];
    return v != null && String(v).trim() !== "";
  });
}
